<template>
  <div class="User" v-loading.fullscreen.lock="fullscreenLoading">
    <!--    顶部-->
    <div class="top">
      <!--      个人信息-->
      <div class="Infos">
        <div style="display: flex">
          <!--        头像-->
          <div class="headerImage">
            <img src="/static/images/HomeTH/ren.jpg" alt="">
          </div>
          <div class="userInfos">
            <!--          名字-->
            <div class="userName">{{ user.UserName }}</div>
            <!--          手机号-->
            <div class="userPhone">{{ user.PhoneNumberStr }}</div>
          </div>
        </div>
        <div class="gotoInfo">
          <el-button type="primary" size="small" icon="el-icon-edit" @click="MyInfo">信息设置</el-button>
          <el-button type="warning" size="small" icon="el-icon-wallet" @click="toCharge">充值</el-button>
        </div>
      </div>
      <!--      灰色分割线-->
      <div class="grey"></div>
      <!--      资产信息-->
      <div class="moneyAbout">
        <div style="font-size: 16px">我的可用余额</div>
        <div>
          <span style="font-size: 18px;font-weight: bold">￥</span>
          <span style="font-size: 18px;font-weight: bold">{{ Balance }}</span>
        </div>
        <div style="font-size: 16px;color: #0066cc">我的使用记录></div>
      </div>
    </div>
    <!--    中间分割线-->
    <div class="midGrey"></div>
    <div class="orderInfos">
      <!--  订单-->
      <div class="orderTop">
        <span style="font-size: 18px;font-weight: bold">最近订单</span>
        <span style="font-size: 14px;color: #0066cc;cursor: pointer" @click="toMyOrder">查看全部订单></span>
      </div>
      <!--      订单详情-->
      <div class="orderDetail" v-for="(item,index) in order" :key="index">
        <div>
          <div style="display: flex;justify-content: space-between;padding: 0 10px 15px 10px;
">
            <span style="font-size: 14px;color: #797979">订单号:{{ item.OrderId }}{{item.ContractCode?`(${item.ContractCode})`:''}}</span>
            <div>
             <span style="font-size: 14px;color: #797979">订单截止时间:
                  <span style="color: #000000;font-weight: bold">{{ item.DeadLineTime | dateNoT }}</span>
              </span>
              <span style="font-size: 14px;color: #797979">单价:
                  <span style="color: #000000;font-weight: bold;margin-left: 10px;">￥{{ item.TransactionPrice }}</span>
              </span>
              <span style="font-size: 14px;color: #797979;margin-left: 10px;">合计:
                <span style="color: #000000;font-weight: bold">￥{{ item.Amount }}</span>
              </span>
            </div>
          </div>
          <div class="orderProduct">
            <!--            产品图片-->
            <div v-if="item.ProductImgPath">
              <img style="width: 120px;height: 120px;" :src="formatPic(item.ProductImgPath)" alt/>
            </div>
            <div v-else>
              <div style="width: 87px;height: 87px;background: #f5f5f5"></div>
            </div>
            <!--            名称/所属库区-->
            <div class="orderState" style="justify-content: space-around;width: 250px">
              <div style="font-size: 18px;font-weight: bold">{{ item.ProductName }}</div>
              <div style="font-size: 14px;">售货单位：{{ item.WarehouseName }}</div>
              <div style="font-size: 14px;display: flex">车牌号：
                <el-tooltip class="item" effect="dark" :content="item.TruckNos?item.TruckNos:'暂无车牌'" placement="bottom-start">
                  <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 100px;display: inline-block">{{item.TruckNos?item.TruckNos:'暂无车牌'}}</span>
                </el-tooltip>
              </div>
            </div>
            <!--            状态-->
            <div class="orderState" style="width: 80px">
              <div v-if="item.OrderStatus == 0">
                <div class="StateInfo" style="color: red">
                  <el-tag type="info" effect="dark">待支付</el-tag>
                </div>
                <!--                此处应为倒计时-->
                <!--                <div style="color: red"><i class="el-icon-loading"></i>1小时25分30秒</div>-->
              </div>
              <div v-else-if="item.OrderStatus == -3 || item.OrderStatus == -6">
                <div class="StateInfo" style="color: red">
                  <el-tag effect="dark">同步中</el-tag>
                </div>
              </div>
              <div v-else-if="item.OrderStatus == 1">
                <div class="StateInfo" style="color: red">
                  <el-tag type="success" effect="dark">已支付</el-tag>
                </div>
              </div>
              <div v-else-if="item.OrderStatus == 2 || item.OrderStatus == 5">
                <div class="StateInfo"><el-tag effect="dark">提货中</el-tag></div>
              </div>
              <div v-else-if="item.OrderStatus == -10">
                <div class="StateInfo">
                  <el-tag type="danger" effect="dark">订单已关闭</el-tag>
                </div>
              </div>
              <div v-else-if="item.OrderStatus == 9 || item.OrderStatus == 8">
                <div class="StateInfo">
                  <el-tag type="success" effect="dark">订单已完成</el-tag>
                </div>
              </div>
              <div v-else-if="item.OrderStatus == 7">
                <div class="StateInfo">
                  <el-tag type="warning" effect="dark">订单提货截止</el-tag>
                </div>
              </div>
              <div v-else-if="item.OrderStatus == -2">
                <div class="StateInfo">
                  <el-tag type="warning" effect="dark">支付超时</el-tag>
                </div>
              </div>
              <div v-else-if="item.OrderStatus == -5">
                <div class="StateInfo">
                  <el-tag type="danger" effect="dark">创建失败</el-tag>
                </div>
              </div>
            </div>
            <!--            按钮-->
            <div style="display: flex;align-items: center;width: 170px">
              <el-button type="text" size="small" @click="toDetail(item.OrderId)">订单详情</el-button>
              <el-button type="text" size="small" v-if="item.OrderStatus == 0" @click="toPay(item.OrderId)">立即支付</el-button>
              <el-button type="text" size="small" v-if="item.OrderStatus == 0" @click="toCancel(item.OrderId)">取消订单</el-button>
              <el-button v-if="item.OrderStatus == 1 || item.OrderStatus == 2 || item.OrderStatus == 5" type="text"
                size="small"
                @click="toFinished(item.OrderId)">完成
              </el-button>
              <el-button v-if="item.OrderStatus == -5 || item.OrderStatus == -1 || item.OrderStatus == -2" type="text" size="small" @click="toDelete(item.OrderId)">删除</el-button>
              <bill-button
                style="margin-left: 10px;"
                size="mini"
                v-if="(item.OrderStatus == 1 || item.OrderStatus == 2) &&  (item.Quantity - item.EstimateQuantity > 0)"
                @saved="onSavedBill"
                :order-id="item.OrderId"
              ></bill-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BillButton from "@/components/Buttons/CreateOrderBillButton";
export default {
  components: {
    BillButton,
  },
  data() {
    return {
      Balance: 999,
      user: {
        UserName: '',
        PhoneNumberStr: ''
      },
      order: [
      ],
      url: {
        loadData: SZH.assets.api + "/Custom/GetCustomInfoForWeb",
        GetPagingWebOrdersurl: SZH.assets.api + "/Order/GetPagingWebOrders",
        CancelOrder: SZH.assets.api + '/Order/CancelOrder',
        FinshOrder: SZH.assets.api + '/Order/FinshOrder',
        DeleteOrder: SZH.assets.api + '/Order/DeleteOrder',
      },
      fullscreenLoading:false
    }
  },
  methods: {
    toDelete(id){
      var self = this;
      self.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.fullscreenLoading = true;
        self.$http.post(self.url.DeleteOrder, {
          KeyValue: id
        }).then(result => {
          if (result.state == true) {
            self.$message({
              type: 'success',
              message:'操作成功'
            });
            self.GetPagingWebOrders()
          } else {
            self.$message({
              type: 'error',
              message: result.message
            });
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
        });

      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    toFinished(id){
      var self = this;
      self.$confirm('确定要完成订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.fullscreenLoading = true;
        self.$http.post(self.url.FinshOrder, {
          KeyValue: id
        }).then(result => {
          if (result.state == true) {
            self.$message({
              type: 'success',
              message:'操作成功'
            });
            self.GetPagingWebOrders()
          } else {
            self.$message({
              type: 'error',
              message: result.message
            });
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
        });

      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    toCancel(id){
      var self = this;
      self.$confirm('确定要取消订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.fullscreenLoading = true;
        self.$http.post(self.url.CancelOrder, {
          KeyValue: id
        }).then(result => {
          if (result.state == true) {
            self.$message({
              type: 'success',
              message:'操作成功'
            });
            self.GetPagingWebOrders()
          } else {
            self.$message({
              type: 'error',
              message: result.message
            });
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
        });

      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    onSavedBill(){
      this.GetPagingWebOrders();
    },
    toCharge(){
      let self = this;
      self.$router.push({
        path:'/Menu/Charge'
      })
    },
    toMyOrder(){
      let self = this;
      self.$router.push({
        path:'/My/OrderList'
      })
    },
    loadUserInfos() {
      let self = this
      self.$http.post(self.url.loadData, {}).then(result => {
        if (result.state == true && result.data != null) {
          for (let i in self.user) {
            if (result.data[i] != undefined) {
              self.user[i] = result.data[i];
            } else {
              self.user[i] = null;
            }
          }
        } else {
        }
      })
    },
    formatPic(path) {
      return SZH.assets.image + path;
    },
    toFixed(num) {
      return parseFloat(num != null && num != undefined ? num.toFixed(2) : '0.00')
    },
    GetPagingWebOrders() {
      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url.GetPagingWebOrdersurl, {
        Data: {
          OrderStatus: 'All',
          BeginTime: '',
          EndTime: '',
        },
        PageSize: 6,
        PageIndex: 1
      }).then(result => {
        if (result.state == true && result.data.Data && result.data.Data.length > 0) {
          self.order = result.data.Data
        } else {
          self.order = []
        }
        self.fullscreenLoading = false;
      },()=>{
        self.fullscreenLoading = false;
      })
    },
    MyInfo() {
      let self = this;
      self.$router.push({
        path: 'Set'
      })
    },
    toPay(id){
      this.$router.push({
        path:'/Menu/PayOrder',
        query:{
          OrderId:id
        }
      })
    },
    toDetail(id){
      this.$router.push({
        path:'/My/orderdetail',
        query:{
          id:id
        }
      })
    },

  },
  computed: {},
  mounted() {
    let self = this;
    self.loadUserInfos();
    self.GetPagingWebOrders()
  },
}
</script>

<style scoped>
.User {
  position: relative;
}

.top {
  display: flex;
  position: relative;
}

.Infos {
  display: flex;
  justify-content: space-between;
  width: 66%;
}

.headerImage {
  width: 100px;
  height: 100px;
}

.headerImage img {
  width: 88px;
  height: 91px;
}

.userInfos {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.userName {
  font-size: 17px;
  font-weight: bold;
}

.userPhone {
  font-size: 14px;
}

.gotoInfo {
  display: flex;
  align-items: center;
  padding-right: 40px;
}

.grey {
  width: 15px;
  height: 134px;
  background: #f5f5f5;
  position: absolute;
  left: 64%;
  top: -20px;

}

.moneyAbout {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 34%;
  padding-left: 20px;
  display: none;
}

.midGrey {
  width: 106%;
  height: 15px;
  background: #f5f5f5;
  position: absolute;
  left: -21px;
  margin-top: 13px;
}

.orderInfos {
  margin-top: 50px;
}

.orderTop {
  display: flex;
  justify-content: space-between;
  height: 37px;
}

/*订单详情*/
.orderDetail {
  width: 100%;
  border: 1px solid #cccbcbc2;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 25px;
}

.orderProduct {
  display: flex;
  border-top: 1px solid #cccbcbc2;
  padding: 10px;
  justify-content: space-between;
}

.orderState {
  display: flex;
  justify-content: center;
  flex-direction: column;
  /*align-items: center;*/
}

.StateInfo {
  font-size: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/userInfo/userInfo.vue